// Constants shared between all-claims and form0781 (and any other
// disability-benefits form apps) to avoid direct cross-app imports.

export const MAX_FILE_SIZE_MB = 100;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 ** 2; // binary based

export const MAX_PDF_FILE_SIZE_MB = 100;
export const MAX_PDF_FILE_SIZE_BYTES = MAX_PDF_FILE_SIZE_MB * 1024 ** 2; // binary based

// values to represent whether a rated disability is service-connected
export const SERVICE_CONNECTION_TYPES = {
  notServiceConnected: 'NOTSVCCON',
  serviceConnected: 'SVCCONNCTED',
};

export const BANK_KEYS = [
  'bankAccountType',
  'bankAccountNumber',
  'bankRoutingNumber',
  'bankName',
];

/**
 * Origins for destructive modal triggers.
 * SIDENAV is used when deferred navigation is initiated by the side nav.
 * CONTINUE is used when the destructive modal is triggered from page actions.
 */
export const DESTRUCTIVE_NAV_TRIGGER_ORIGINS = Object.freeze({
  SIDENAV: 'sidenav',
  CONTINUE: 'continue',
});

// sessionStorage key written by Form526EZApp indicating whether the modern
// (syncModern0781Flow) 0781 flow is active for the current form session.
export const TRACKING_526EZ_0781_FLOW = '21-526EZ_syncModern0781Flow';

// Session storage keys for tracking
export const TRACKING_526EZ_SIDENAV_BACK_BUTTON_CLICKS =
  '21-526EZ_backButtonClickCount';
export const TRACKING_526EZ_SIDENAV_CONTINUE_BUTTON_CLICKS =
  '21-526EZ_continueButtonClickCount';
export const TRACKING_526EZ_SIDENAV_CLICKS = '21-526EZ_sideNavClickCount';
export const TRACKING_526EZ_SIDENAV_FORM_START = '21-526EZ_formStartTracked';
export const TRACKING_526EZ_SIDENAV_FEATURE_TOGGLE = '21-526EZ_sidenavEnabled';

// RUM session tracking storage keys (form data and sessionStorage cache)
export const TRACKING_526EZ_RUM_SESSION_IDS_FORM = 'view:sessionIds';
export const TRACKING_526EZ_RUM_SESSION_IDS_STORAGE = '21-526EZ_sessionIds';

// BDD SHA tracking storage keys
export const TRACKING_526EZ_BDD_SHOWN_SHA_INTRO = '21-526EZ_bddShownShaIntro';
export const TRACKING_526EZ_BDD_SHOWN_SHA_UPLOAD = '21-526EZ_bddShownShaUpload';
export const TRACKING_526EZ_BDD_SHOWN_SHA_VALIDATION_ALERT =
  '21-526EZ_bddShownShaValidationAlert';

/** Public Disability Benefits Questionnaires (DBQs) page which links to the Separation Health Assessment Part A */
export const DBQ_URL =
  'https://www.benefits.va.gov/compensation/dbq_publicdbqs.asp';

export const SHA_PART_A_PDF_URL =
  'https://www.benefits.va.gov/compensation/docs/SHA_DBQ_Part_A_Self-Assessment.pdf';
